import React, { useEffect, useState } from "react";
import CommonTable from "../sharedComponents/CommonTable";
import {
  Box,
  Button,
  ListItemIcon,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import Add from "@mui/icons-material/Add";
import { CommonDialog } from "../sharedComponents/CommonDialog";
import {
  getDeleteFlowAction,
  getFlowActionsList,
} from "../../service/ApiService";
import { useLocation } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfirmationPopup from "../sharedComponents/ConfirmationPopup";
import EditIcon from "@mui/icons-material/Edit";
import AlertMsg from "../sharedComponents/Alert";
import GroupsView from "../groups/GroupsView";

const ActionsView: React.FC = () => {
  const location = useLocation();
  const [actionsList, setActionsList] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertData, setAlertData] = useState<any>();
  const featureId: any = new URLSearchParams(location.search).get("featureId");

  useEffect(() => {
    getActionslist();
  }, []);

  const getActionslist = () => {
    setIsLoading(true);
    const flowId: any = new URLSearchParams(location.search).get("flowId");
    getFlowActionsList(flowId)
      .then((response: any) => {
        setActionsList([]);
        if (response && response.length > 0) {
          const filteredResponse = response.filter(
            (item: any) => !item.isDeleted
          );
          setActionsList(filteredResponse);
        }
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      })
      .catch((error: any) => {
        setIsLoading(false);
      });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickClose = (isSubmitted: boolean) => {
    setOpen(false);
    setSelectedRowData(null);
    if (isSubmitted) {
      getActionslist();
    }
  };

  const handleEditItem = (rowData: any, type: string) => {
    let tempObj: any = { ...rowData };
    setSelectedRowData(tempObj);
    if (type === "edit") {
      setOpen(true);
    } else if (type === "delete") {
      OpenConfirmationPop();
    }
  };

  const columns: any = [
    {
      accessorKey: "id",
      header: "ID",
      size: 50,
    },
    {
      accessorKey: "name",
      header: "Name",
      size: 350,
    },
    {
      accessorKey: "input",
      header: "Input",
      accessorFn: (row: any) => (
        <div title={row.input} className="truncate cursor-pointer">
          {row.input}
        </div>
      ),
    },
  ];

  const renderCustomToolbar = () => {
    return (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h6">Actions</Typography>
        <Button variant="outlined" onClick={handleClickOpen}>
          <Add /> Add new action
        </Button>
      </Box>
    );
  };

  const renderRowActionMenuItems = (props: any) => {
    return [
      <MenuItem
        key={0}
        onClick={() => {
          handleEditItem(props.row.original, "edit");
          props.closeMenu();
        }}
        sx={{ m: 0 }}
      >
        <ListItemIcon>
          <EditIcon />
        </ListItemIcon>
        Edit
      </MenuItem>,
      <MenuItem
        key={1}
        onClick={() => {
          handleEditItem(props.row.original, "delete");
          props.closeMenu();
        }}
        sx={{ m: 0 }}
      >
        <ListItemIcon>
          <DeleteIcon />
        </ListItemIcon>
        Delete
      </MenuItem>,
    ];
  };
  const ConfirmationPopClose = () => {
    setOpenConfirmation(false);
  };

  const OpenConfirmationPop = () => {
    setOpenConfirmation(true);
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const DeleteFlowAction = () => {
    getDeleteFlowAction(selectedRowData?.id)
      .then((response: any) => {
        setOpenSnackbar(true);
        if (response.success) {
          setAlertData({
            type: true,
            msg: `The action has been deleted successfully`,
          });
          getActionslist();
        } else {
          setAlertData({
            type: false,
            msg:
              response.errorMessage ?? `The action deletion was unsuccessful`,
          });
        }
        ConfirmationPopClose();
      })
      .catch((error: any) => {
        console.log("error", error);
      });
  };

  return (
    <div className="container mx-auto">
      <div>
        <CommonTable
          columnsList={columns}
          dataList={actionsList || []}
          isLoading={isLoading}
          renderCustomToolbar={renderCustomToolbar}
          renderRowActionMenuItems={renderRowActionMenuItems}
          enableRowActions={true}
          positionActionsColumn="last"
        />
        <CommonDialog
          isOpen={open}
          title={`${selectedRowData?.id ? "Edit action" : "Add new action"}`}
          actionType="upsertAction"
          dataToSet={selectedRowData}
          handleClose={handleClickClose}
          dialogwidth="80%"
        />
        <ConfirmationPopup
          isOpen={openConfirmation}
          description="Are you sure you want to delete the action?"
          handleClose={ConfirmationPopClose}
          handleConfirm={DeleteFlowAction}
        />
        <AlertMsg
          openSnackbar={openSnackbar}
          alertdata={alertData}
          onClose={handleSnackbarClose}
        />
      </div>

      {/* Only vissible for interview preparation */}
      {featureId == 8 && (
        <div className="mt-8">
          <GroupsView />
        </div>
      )}
    </div>
  );
};

export default ActionsView;
